import { Route } from '@angular/router';
import { pagePermissionActivate } from '../page-permission';

/** System pages under `/system/...` (default: `system/dashboard`). */
export const systemRoutes: Route = {
    path: 'system',
    data: { title: 'system' },
    children: [
        { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
        {
            path: 'dashboard',
            loadComponent: () => import('./dashboard/dashboard.component').then((m) => m.DashboardComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Dashboard' },
        },
        {
            path: 'login-log',
            loadComponent: () => import('./login-log/login-log.component').then((m) => m.LoginLogComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'login-log' },
        },
        {
            path: 'audit-log',
            loadComponent: () => import('./audit-log/audit-log.component').then((m) => m.AuditLogComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'audit-log' },
        },
        {
            path: 'roles',
            loadComponent: () => import('./roles/roles.component').then((m) => m.RolesComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'roles' },
        },
        {
            path: 'profession',
            loadComponent: () => import('./profession/profession.component').then((m) => m.ProfessionComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'profession' },
        },
        {
            path: 'currency',
            loadComponent: () => import('./currency/currency.component').then((m) => m.CurrencyComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'currency' },
        },
        {
            path: 'soil-type',
            loadComponent: () => import('./soil-type/soil-type.component').then((m) => m.SoilTypeComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'soil-type' },
        },
        {
            path: 'country',
            loadComponent: () => import('./country/country.component').then((m) => m.CountryComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'country' },
        },
        {
            path: 'city',
            loadComponent: () => import('./city/city.component').then((m) => m.CityComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'City' },
        },
        {
            path: 'climate-zone-agricultural-class',
            loadComponent: () =>
                import('./climate-zone-agricultural-class/climate-zone-agricultural-class.component').then(
                    (m) => m.ClimateZoneAgriculturalClassComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'Climate zone agricultural class' },
        },
        {
            path: 'climate-zone-class',
            loadComponent: () =>
                import('./climate-zone-class/climate-zone-class.component').then((m) => m.ClimateZoneClassComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Climate zone class' },
        },
        {
            path: 'climate-zone',
            loadComponent: () => import('./climate-zone/climate-zone.component').then((m) => m.ClimateZoneComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Climate zone' },
        },
        {
            path: 'customer',
            loadComponent: () => import('./customer/customer.component').then((m) => m.CustomerComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Customer' },
        },
        {
            path: 'district',
            loadComponent: () => import('./district/district.component').then((m) => m.DistrictComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'District' },
        },
        {
            path: 'region',
            loadComponent: () => import('./region/region.component').then((m) => m.RegionComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Region' },
        },
        {
            path: 'state',
            loadComponent: () => import('./state/state.component').then((m) => m.StateComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'State' },
        },
        {
            path: 'village',
            loadComponent: () => import('./village/village.component').then((m) => m.VillageComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Village' },
        },
        {
            path: 'permission-type',
            loadComponent: () =>
                import('./permission-type/permission-type.component').then((m) => m.PermissionTypeComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Permission type' },
        },
        {
            path: 'permissions',
            loadComponent: () => import('./permissions/permissions.component').then((m) => m.PermissionsComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Permissions' },
        },
        {
            path: 'blocked-password-list',
            loadComponent: () =>
                import('./blocked-password-list/blocked-password-list.component').then((m) => m.BlockedPasswordListComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Blocked password list' },
        },
    ],
};
